import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="construction-container">
        <h1 className="title">Under Construction</h1>
        <p className="message">Our website is getting a fresh look. Stay tuned for something awesome!</p>
        <div className="tools">
          <span className="tool">🔨</span>
          <span className="tool">🛠️</span>
          <span className="tool">⚙️</span>
        </div>
      </div>
    </div>
  );
}

export default App;
